import { render, staticRenderFns } from "./LinhaObservacao.vue?vue&type=template&id=60a04b1e&scoped=true"
import script from "./LinhaObservacao.vue?vue&type=script&lang=js"
export * from "./LinhaObservacao.vue?vue&type=script&lang=js"
import style0 from "./LinhaObservacao.vue?vue&type=style&index=0&id=60a04b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a04b1e",
  null
  
)

export default component.exports